import React from "react";
import AddIcon from '@mui/icons-material/Add';
export default function IconAdd({size = 15, style}) {
    return(
        <AddIcon size={size} sx={{...styles.icon, ...style}}/>
    )
}

const styles = {
    icon: {
        color: '#003300',
        ':hover': {
            color: '#002900',
            backgroundColor: 'unset'
        },
        ':disabled': {
            color: '#003300b0',
        },
        ':active': {
            outline: '0',
            color: '#003300',
        },
    }
}